import {
  PartnerTransferSection,
  PartnerTransferTypes,
} from 'further-types/lp/partner-transfer';

export const PartnerTransferSectionLabels = {
  [PartnerTransferSection.PartnerTransfer]: 'Partner Transfer',
  [PartnerTransferSection.Investments]: 'Investments',
  [PartnerTransferSection.IncomeAndExpenses]: 'Income & Expenses',
  [PartnerTransferSection.Realisations]: 'Realisations',
  [PartnerTransferSection.Fees]: 'Fees',
  [PartnerTransferSection.CapitalActions]: 'Capital Actions',
  [PartnerTransferSection.Summary]: 'Summary',
};

export const PartnerTransferTypeLabels = {
  [PartnerTransferTypes.PartnerTransfer]: 'Capital Action (Partner Transfer)',
};
